// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../../graphql/api/index';

import { ImageLargeFragmentDoc } from '../../imageLarge.fragment.generated';
import { ImageCommonFragmentDoc } from '../../imageCommon.fragment.generated';
import { ImageSizeFragmentDoc } from '../../imageSize.fragment.generated';
export const BlogPostPreviewFragmentDoc = `
    fragment blogPostPreview on Post {
  id
  title
  slug
  excerpt
  date
  featuredImage {
    ...imageLarge
  }
}
    `;